import { ErrorPageContentProps } from "content/error/types";

export enum ErrorType {
    API = "api",
    REFERRAL = "referral",
    ADVOCATE = "advocate",
    NOT_FOUND = "notFound",
}

export interface ErrorLayoutProps {
    content: ErrorPageContentProps;

    type?: ErrorType;
}
